
// Реэкспорт клиента Supabase из integrations для избежания дублирования GoTrueClient
import { supabase, supabaseUrl as url, SUPABASE_PUBLISHABLE_KEY as key } from '@/integrations/supabase/client';

// Экспортируем те же переменные для обратной совместимости
const supabaseUrl = url;
const supabaseKey = key;

export { supabase, supabaseUrl, supabaseKey };

// Логирование для подтверждения правильного URL
console.log('✅ Supabase клиент успешно реэкспортирован из integrations с URL:', url);
console.log('✅ Используется ТОЛЬКО прямое подключение без прокси');
